angular.module('dpw.services')
    .factory('defaultGrantTypes', ['api', function (api) {
        var defaultGrantTypesConfig = {};
        return {
            fetch: function (options) {
                var scope = options.scope;
                var typeId = options.typeId;
                var callback = options.callback;
                var delimiter = '@#@';
                var keyName = [scope, typeId].join(delimiter);
                if (getValue()) {// ready
                    invokeCallback();
                } else if (getPromise()) {// requested but not ready
                    getPromise().then(invokeCallback);
                } else {// not requested yet
                    doRequest();
                }

                function doRequest() {
                    _.set(defaultGrantTypesConfig, [keyName, 'promise'],
                        api.call(api.getDefaultGrantTypes({
                            appScope: scope,
                            platformType: typeId
                        }), function (data) {
                            _.set(defaultGrantTypesConfig, [keyName, 'value'], data.grantTypes);
                            invokeCallback();
                        })
                    );
                }

                function invokeCallback() {
                    callback(getValue());
                }

                function getValue() {
                    return _.get(defaultGrantTypesConfig, [keyName, 'value']);
                }

                function getPromise() {
                    return _.get(defaultGrantTypesConfig, [keyName, 'promise']);
                }
            }
        };
    }]);